import React, { useState } from 'react'; // Import useState
import axios from 'axios'; // Import axios
import Navbar from '../Navbar/Navbar';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faMobileAlt, faEnvelopeOpen, faMapPin, faPaperPlane, faChevronDown, faSpinner
} from '@fortawesome/free-solid-svg-icons';
import Footer from '../Footer/Footer';
import './Contact.css';
    const API_BASE_URL = process.env.API_BASE_URL || 'https://api.hitkarihospital.com:5005'; // Your backend API URL

const ContactUs = () => {
    const [formData, setFormData] = useState({
        name: '',
        email: '',
        subject: '',
        message: ''
    });
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [submitStatus, setSubmitStatus] = useState(null); // null, 'success', 'error'
    const [feedbackMessage, setFeedbackMessage] = useState('');

    const handleChange = (e) => {
        const { id, value } = e.target;
        // Derive state key from ID: e.g., 'contactus-input-name' -> 'name'
        const key = id.replace('contactus-input-', '');
        setFormData(prevData => ({
            ...prevData,
            [key]: value
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setSubmitStatus(null);
        setFeedbackMessage('');

        // Basic client-side validation
        if (!formData.name || !formData.email || !formData.message) {
            setSubmitStatus('error');
            setFeedbackMessage('Please fill in all required fields: Name, Email, and Message.');
            setIsSubmitting(false);
            return;
        }
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        if (!emailRegex.test(formData.email)) {
            setSubmitStatus('error');
            setFeedbackMessage('Please enter a valid email address.');
            setIsSubmitting(false);
            return;
        }

        try {
            const response = await axios.post(`${API_BASE_URL}/contactus-submit`, formData);
            if (response.data.success) {
                setSubmitStatus('success');
                setFeedbackMessage(response.data.message || 'Thank you! Your message has been sent.');
                setFormData({ name: '', email: '', subject: '', message: '' }); // Clear form
            } else {
                setSubmitStatus('error');
                setFeedbackMessage(response.data.message || 'An unexpected error occurred. Please try again.');
            }
        } catch (error) {
            setSubmitStatus('error');
            let msg = 'Could not connect to the server. Please check your connection and try again later.';
            if (error.response && error.response.data && error.response.data.message) {
                msg = error.response.data.message;
            } else if (error.message) {
                msg = error.message;
            }
            setFeedbackMessage(msg);
            console.error("Contact form submission error:", error);
        } finally {
            setIsSubmitting(false);
        }
    };

    const scrollToForm = () => {
        document.getElementById('contactus-form-section-anchor')?.scrollIntoView({ behavior: 'smooth' });
    };

    return (
        <>
            <div className="contactus-page-layout">
                <header className="contactus-site-header">
                    <Navbar />
                </header>

                {/* Hero Section (same as Part 1) */}
                <section className="contactus-hero-banner">
                    <div className="contactus-hero-video-bg"></div>
                    <div className="contactus-hero-content-overlay">
                        <div className="contactus-hero-text-container">
                            <h1 className="contactus-hero-main-title">Let's Connect</h1>
                            <p className="contactus-hero-description">
                                Your health journey is important to us. Reach out with any questions or to schedule a consultation.
                                Hitkari Hospital Balotra is here for you.
                            </p>
                            <button onClick={scrollToForm} className="contactus-hero-cta-button">
                                Send a Message <FontAwesomeIcon icon={faChevronDown} className="contactus-hero-cta-icon" />
                            </button>
                        </div>
                    </div>
                </section>

                <main className="contactus-main-wrapper">
                    <div className="contactus-inner-container">
                        {/* Contact Channels Section (same as Part 1) */}
                        <section className="contactus-channels-section">
                            <h2 className="contactus-section-main-title">How Can We Help?</h2>
                            <p className="contactus-section-subtitle">
                                Choose your preferred way to get in touch. We're responsive and ready to assist.
                            </p>
                            <div className="contactus-channels-grid">
                                <div className="contactus-channel-card" id="contactus-channel-phone">
                                    <div className="contactus-channel-icon-wrapper">
                                        <FontAwesomeIcon icon={faMobileAlt} className="contactus-channel-icon" />
                                    </div>
                                    <h3 className="contactus-channel-title">Phone Number</h3>
                                    <p className="contactus-channel-detail">7378125151</p>
                                    <a href="tel:7378125151" className="contactus-channel-action">Call Now</a>
                                </div>

                                <div className="contactus-channel-card" id="contactus-channel-email">
                                    <div className="contactus-channel-icon-wrapper">
                                        <FontAwesomeIcon icon={faEnvelopeOpen} className="contactus-channel-icon" />
                                    </div>
                                    <h3 className="contactus-channel-title">Send An Email</h3>
                                   <p className="contactus-channel-detail">contact@hitkarihospital.com</p>
                                    <a href="mailto:hitkarihospitalblt2015@gmail.com" className="contactus-channel-action">Email Us</a>
                                </div>

                                <div className="contactus-channel-card" id="contactus-channel-address">
                                    <div className="contactus-channel-icon-wrapper">
                                        <FontAwesomeIcon icon={faMapPin} className="contactus-channel-icon" />
                                    </div>
                                    <h3 className="contactus-channel-title">Visit Our Hospital</h3>
                                    <p className="contactus-channel-detail">
                                        Neelam Cinema Ke Pass, BALOTRA, <br />
                                        DISTT.- BARMER (RAJASTHAN), PIN – 344022
                                    </p>
                                     <a href="#contactus-map-location-section" onClick={(e) => {e.preventDefault(); document.getElementById('contactus-map-location-section')?.scrollIntoView({behavior: 'smooth'});}} className="contactus-channel-action">Get Directions</a>
                                </div>
                            </div>
                        </section>

                        {/* Contact Form Section - WITH STATE AND SUBMISSION */}
                        <section className="contactus-form-section" id="contactus-form-section-anchor">
                             <div className="contactus-form-container-card">
                                <div className="contactus-form-header">
                                    <h2 className="contactus-section-main-title contactus-form-title-custom">Leave Us a Message</h2>
                                    <p className="contactus-section-subtitle contactus-form-subtitle-custom">
                                        Fill out the form below, and we'll get back to you as soon as possible.
                                    </p>
                                </div>
                                <form id="contactus-main-message-form" className="contactus-message-form-layout" onSubmit={handleSubmit}>
                                    <div className="contactus-form-row">
                                        <div className="contactus-form-field-group">
                                            <label htmlFor="contactus-input-name" className="contactus-field-label">Full Name *</label>
                                            <input
                                                type="text"
                                                id="contactus-input-name"
                                                className="contactus-input-control"
                                                placeholder="Your Full Name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                        <div className="contactus-form-field-group">
                                            <label htmlFor="contactus-input-email" className="contactus-field-label">Email Address *</label>
                                            <input
                                                type="email"
                                                id="contactus-input-email"
                                                className="contactus-input-control"
                                                placeholder="your.email@example.com"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                        </div>
                                    </div>
                                    <div className="contactus-form-field-group">
                                        <label htmlFor="contactus-input-subject" className="contactus-field-label">Subject <span className="contactus-label-optional"></span></label>
                                        <input
                                            type="text"
                                            id="contactus-input-subject"
                                            className="contactus-input-control"
                                            placeholder="What is this regarding?"
                                            value={formData.subject}
                                            onChange={handleChange}
                                        />
                                    </div>
                                    <div className="contactus-form-field-group">
                                        <label htmlFor="contactus-input-message" className="contactus-field-label">Your Message *</label>
                                        <textarea
                                            id="contactus-input-message"
                                            className="contactus-input-control contactus-textarea-control"
                                            rows="5"
                                            placeholder="Please describe your inquiry..."
                                            value={formData.message}
                                            onChange={handleChange}
                                            required
                                        ></textarea>
                                    </div>

                                    {feedbackMessage && (
                                        <div className={`contactus-form-feedback-display ${submitStatus === 'success' ? 'contactus-feedback-type-success' : 'contactus-feedback-type-error'}`}>
                                            {feedbackMessage}
                                        </div>
                                    )}

                                    <div className="contactus-form-submit-area">
                                        <button type="submit" className="contactus-primary-submit-button" disabled={isSubmitting}>
                                            {isSubmitting ? (
                                                <>
                                                    <FontAwesomeIcon icon={faSpinner} spin style={{ marginRight: '10px' }} /> Sending...
                                                </>
                                            ) : (
                                                <>
                                                    <FontAwesomeIcon icon={faPaperPlane} /> Send Message
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </section>

                        {/* Map Location Section (same as Part 1) */}
                        <section className="contactus-map-location-section" id="contactus-map-location-section">
                             <h2 className="contactus-section-main-title">Our Location</h2>
                            <p className="contactus-section-subtitle">
                                Easily find Hitkari Hospital Balotra. We look forward to welcoming you.
                            </p>
                            <div className="contactus-map-frame-wrapper">
                                <iframe
                                    id="contactus-location-gmap"
                                    title="Hitkari Hospital Balotra Location"
                                    src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3617.226496256967!2d72.23543557609034!3d25.832510177747292!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3945024a0f475671%3A0xdc83537965547f04!2sNEAR%20MTM%20SCHOOL%2C%20BALOTRA!5e0!3m2!1sen!2sin!4v1701123487557!5m2!1sen!2sin"
                                    width="100%"
                                    height="550"
                                    style={{ border: '0' }}
                                    allowFullScreen={true}
                                    loading="lazy"
                                    referrerPolicy="no-referrer-when-downgrade">
                                </iframe>
                            </div>
                        </section>
                    </div>
                </main>
            </div>
            <Footer />
        </>
    );
};

export default ContactUs;